const influencers = [
	{
		path: '/agency/influencers/list',
		name: 'agency-influencers-list',
		component: () => import('@/views/agency/influencers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,influencers',
		},
	},
	{
		path: '/agency/influencers/new',
		name: 'agency-influencers-create',
		component: () => import('@/views/agency/influencers/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,influencers',
		},
	},
	{
		path: '/agency/influencers/edit/:id',
		name: 'agency-influencers-edit',
		component: () => import('@/views/agency/influencers/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,influencers',
		},
	},
]

export default influencers
